class Source {
  constructor() {
    this.embeddable = false
    this.inputs = {
      MAIN: "MainTuner",
      VOD: "None",
      HLS: "None",
      MULTICAST: "MainTuner",
      RF: "MainTuner",
      HDMI1: "HDMI1",
      HDMI2: "HDMI2",
      HDMI3: "HDMI3"
    }
  }
  _init = async () => {
    const current = await this.get().catch(err => _$.error(err))

    if (current !== this.inputs.MAIN)
      await this.set("None")
        .then(res => {
          if (!res) this.set("MainTuner")
          return true
        })
        .catch(err => _$.error(err))

    return true
  }

  get = async () => {
    let promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.SOURCE}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.SOURCE,
      CmdType: "Request",
      Fun: "Source"
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return _$.error(payload.detail)
    else return payload.detail.TunedSource
  }
  set = async source => {
    let promise = await _$.progress.create()
    _$.vue.$once([`event${__._api.cookies.SOURCE}`, "source"], payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.SOURCE,
      CmdType: "Change",
      Fun: "Source",
      CommandDetails: {
        TuneToSource: source
      }
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return _$.error(payload.detail)
    else return true
  }
}

export default Source
